import { createMissingZones } from "./edit"
import { insertNewGeometry } from "./insert"
import { MinimumZoneArea } from "./polygons"
import { IMapTopologyService } from "./topo/types"
import { ol_Feature, ol_geom } from "@omnia/exports/openlayers";

export function splitAlongPolygon<Zone extends { feature: ol_Feature }>(
    geometry: ol_geom.Geometry,
    layer: { zones: Zone[] },
    outerBoundary: ol_geom.Geometry,
    topo: IMapTopologyService,
    createNewZone: (geometry: ol_geom.Geometry, initialZone?: Zone) => void,
    removeZone: (zone: Zone) => void,
    splitOnExistingZones: boolean,
    minimumArea: number = MinimumZoneArea
) {

    const intersection = topo.intersection(outerBoundary, geometry)
    if (!intersection) return false
    if (!intersection.isValid()) return false

    geometry = intersection.getOpenLayersGeometry()

    return insertNewGeometry(geometry, layer, topo, createNewZone, removeZone, splitOnExistingZones, minimumArea)

}

export function splitAlongLine<Zone extends { feature: ol_Feature }>(
    line: ol_geom.Geometry,
    zones: Zone[],
    outerBoundary: ol_geom.Geometry,
    createNewZone: (geom: ol_geom.Geometry, initialZone: Zone) => void,
    topo: IMapTopologyService
) {

    const updatedZones = zones
        .filter(z => !!z.feature)
        .map(z => splitSingleZone(z, line, topo))
        .filter(z => !!z)

    for (const z of updatedZones) {

        z.intersections.forEach((i, index) => {

            const olg = i.intersection.getOpenLayersGeometry()

            if (index == 0) {
                z.zone.feature.setGeometry(olg)
            }
            else {
                createNewZone(olg, z.zone)
            }

        })

    }

    if (outerBoundary) {
        createMissingZones(zones, topo, outerBoundary, g => createNewZone(g, undefined))
    }

}


function splitSingleZone<Zone extends { feature: ol_Feature }>(z: Zone, splitLimit: ol_geom.Geometry, topo: IMapTopologyService) {

    const zoneGeometry = z.feature.getGeometry()

    const splits = topo.polygonize([zoneGeometry, splitLimit])

    if (splits && splits.length > 1) {

        let intersections = splits.map(s => {

            const intersection = topo.intersection(zoneGeometry, s)

            if (intersection && (intersection.getType() == "Polygon") && (intersection.getDimension() == 2)) {

                const area = intersection.getArea()

                if (area && (area >= MinimumZoneArea)) {

                    return {
                        intersection,
                        area
                    }

                }
            }

        })


        intersections = intersections.filter(i => !!i)

        intersections = intersections.sort((i1, i2) => i2.area - i1.area)

        return {
            zone: z,
            intersections
        }

    }

}
